<template>
  <footer class="controls">
    <div class="left-actions">
      <slot name="left"></slot>
    </div>
    <n-page-indicator :currentPage="currentPage" :numPages="numPages" />
    <div class="right-actions">
      <slot name="right"></slot>
    </div>
  </footer>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NModalFooter extends Vue {
  @Prop({ type: Number, default: 0 }) numPages!: number
  @Prop({ type: Number, default: 1 }) currentPage!: number
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

footer {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-content: center;
  align-items: center;
  padding-top: $notch-space-8x;
  width: 100%;

  @include mobile {
    display: block;
  }

  .right-actions {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    gap: $notch-space-2x;
  }

  .indicators {
    > span {
      font-size: 20px;
    }

    > * + * {
      margin-left: $notch-space-2x;
    }
  }
}
</style>
